// shared-data.service.ts
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SharedDataService {
  private dataSubject = new Subject<any>();
  data$ = this.dataSubject.asObservable(); // Observable for subscribers

  sendData(data: any) {
    this.dataSubject.next(data); // Emit data
  }
}
